import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { BsArrowRepeat } from "react-icons/bs";
import { FaStar, FaRegStar } from 'react-icons/fa';

const MerchantPerformance = () => {
    return (
        <Wrapper>
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                        <div>
                            <h4 className="text-dark mb-1 d-flex align-items-center">
                                Merchant Performance
                            </h4>
                            <p className="text-muted mb-0">
                                View merchant performance based on ticket sales and revenue
                            </p>
                        </div>
                    </div>

                    {/* Filter Row */}
                    <div className="row g-2 align-items-center mb-3">
                        <div className="col-md-auto col-12">
                            <input
                                type="text"
                                className="form-control merchant-performance"
                                placeholder="Search ID, Customer, Service"
                            />
                        </div>
                       
                        <div className="col-md-auto col-12">
                            <select className="form-select">
                                <option>All Time</option>
                            </select>
                        </div>
                         <div className="col-md-auto col-12">
                            <select className="form-select">
                                <option>All Ratings</option>
                            </select>
                        </div>
                        <div className="col-md-auto col-12">
                            <button className="btn btn-outline-secondary d-flex align-items-center gap-1 w-100">
                                <BsArrowRepeat size={16} />
                                Clear Filters
                            </button>
                        </div>
                    </div>

                    {/* Table */}
                    <TableWrapper>
                        <table>
                            <thead>
                                <tr>
                                    <th>Merchant Name</th>
                                    <th>Partner ID</th>
                                    <th>Merchant Category</th>
                                    <th>Ratings</th>
                                    <th>View Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Quick Bites Shack</td>
                                    <td>M2873</td>
                                    <td><span className="badge fastfood">Fast Food, Snack, Sweets & Beverages Outlet</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐☆ <small>(4.0)</small></span></td> */}
                                    <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">2,250</td>
                                </tr>
                                <tr>
                                    <td>Market Street Food Cart</td>
                                    <td>M1938</td>
                                    <td><span className="badge streetstall">Street Stalls</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐⭐ <small>(4.4)</small></span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">1,850</td>
                                </tr>
                                <tr>
                                    <td>Luigi's Pizzeria</td>
                                    <td>M4910</td>
                                    <td><span className="badge restaurant">Restaurant</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐⭐ <small>(4.8)</small></span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">1,550</td>
                                </tr>
                                <tr>
                                    <td>Gourmet Bites Cafe</td>
                                    <td>M7263</td>
                                    <td><span className="badge restaurant">Restaurant</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐⭐ <small>(4.5)</small></span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">1,250</td>
                                </tr>
                                <tr>
                                    <td>The Daily Grind Cafe</td>
                                    <td>M3027</td>
                                    <td><span className="badge bakery">Bakeries & Cafes</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐☆ <small>(4.3)</small></span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">1,120</td>
                                </tr>
                                <tr>
                                    <td>Artisan Goods Emporium</td>
                                    <td>M5387</td>
                                    <td><span className="badge other">Other Merchant</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐⭐☆ <small>(4.1)</small></span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">920</td>
                                </tr>
                                <tr>
                                    <td>The Local Corner Store</td>
                                    <td>M6152</td>
                                    <td><span className="badge fastfood">Fast Food, Snack, Sweets & Beverages Outlet</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐½☆ <small>(3.8)</small></span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">880</td>
                                </tr>
                                <tr>
                                    <td>Ye Olde Curio Shoppe</td>
                                    <td>M0854</td>
                                    <td><span className="badge other">Other Merchant</span></td>
                                    {/* <td><span className="stars">⭐⭐⭐½☆ <small>(3.5)</small></span></td> */}
                                     <td>
                                        <span className="stars" style={{ color: '#f5a623' }}>
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaStar />
                                            <FaRegStar />
                                            <small style={{ marginLeft: '5px' }}>(4.0)</small>
                                        </span>
                                    </td>
                                    <td className="view-count">610</td>
                                </tr>
                            </tbody>
                        </table>
                    </TableWrapper>
                </div>
            </div>
        </Wrapper>
    );
};

export default MerchantPerformance;

const Wrapper = styled.div`
  .view-count {
    color: #0d6efd;
    font-weight: 500;
    cursor: pointer;
  }
    input.form-control.merchant-performance {
    width: 359px;
}
`;

const TableWrapper = styled.div`
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  th, td {
    padding: 12px;
    border: 1px solid #dee2e6;
    text-align: left;
    vertical-align: middle;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }

  .badge {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
  }

  .fastfood {
    background-color: rgba(255, 165, 0, 0.2);
    color: #d35400;
  }

  .streetstall {
    background-color: rgba(0, 255, 127, 0.2);
    color: #2ecc71;
  }

  .restaurant {
    background-color: rgba(255, 0, 60, 0.1);
    color: #e74c3c;
  }

  .bakery {
    background-color: rgba(255, 255, 0, 0.2);
    color: #f1c40f;
  }

  .other {
    background-color: rgba(0, 123, 255, 0.1);
    color: #0d6efd;
  }

  .stars {
    white-space: nowrap;
    font-size: 16px;
    color: #f4c150;
  }

  small {
    font-size: 12px;
    color: #555;
  }
`;
